@if (loadingData) {
  <ebs-spinner [spinnerMessage]="''" [faColour]="'#fff'" [boxColour]="'#fff'"
  [boxPadding]="'5px 15px'" [faFont]="'2.2rem'"></ebs-spinner>
}

@if (!loadingData && showError) {
  <div>
    <i class="fa fa-fw fa-lg fa-exclamation-circle"> </i> {{failedMessage}}
  </div>
}

@if (!loadingData && courseStructure) {
  <ul class="list-unstyled">
    <li class="divider button-wrapper d-none d-md-block" (click)="toggleMenuSide(menuStartPosition)" title="Menu toggle">
      <!--Closes and Opens the Sidebar-->
      <button type="button" id="sidebarCollapse" class="btn btn-sidebar-trigger">
        <span class="{{menuStartPosition}}"></span>
        <span class="sr-only">minimise maximise sidebar</span>
      </button>
    </li>
    <!--top links-->
    <!--hide downloads for now-->
    @for (link of courseStructure.links; track link) {
      <li title="{{link.name}}"
        [className]="link.active ? 'divider active' : 'divider inactive'">
        @if (!isOffline || link.name === 'Course Dashboard') {
          <a [routerLink]="link.url">
            <span class="nav-label-icon-left fa fa-fw {{link.icon}}"></span>
            <span class="nav-label icon-left space-adjustment"> {{link.name}} </span>
          </a>
        }
        @if (isOffline && link.name != 'Course Dashboard') {
          <a  (click)="offlineModal()">
            <span class="nav-label-icon-left icon-gecko-unavailable" style="padding-top: 4px;" ></span>
            <span class="nav-label icon-left space-adjustment"> {{link.name}} </span>
          </a>
        }
      </li>
    }
    <!--Module-->
    <li class="nav-title">Learning Modules: ({{calculateCompletePerecent()}}% complete)</li>
    <div>
      @for (module of courseStructure.modules; track module; let i = $index) {
        <li class="dropdown" title="{{module.name}}">
          <button (click)="toggleModule(i, true)" [attr.aria-expanded]="!isCollapsed[i]" class="{{collapsedClass[i]}}">
            @if (!(isOffline && !module.isContentDownloaded) ) {
              <span class="nav-index">{{module.number}}</span>
            }
            @if (isOffline && !module.isContentDownloaded) {
              <span class="nav-index icon-gecko-unavailable" style="padding-top: 4px;"></span>
            }
            <span class="nav-label">
              {{module.name}}
              <ebs-progress-bar [progressWrapperWidth]="'100%'" [progressMax]="module.progressMax"
                [progressValue]="module.progressValue" [progressAnimate]="true" [progressType]="'success'">
              </ebs-progress-bar>
            </span>
          </button>
          <!--section-->
          <ul class="list-unstyled section-list" [@isCollapsedAnimation]="isCollapsed[i]">
            @for (section of module.sections; track section; let j = $index) {
              <li [className]="section.active ? 'active' : 'inactive'">
                @if (!isOffline || section.availableOffline) {
                  <a [routerLink]="['/' + section.uri]" class="btn" role="button" aria-label="link button"
                    >
                    <span class="nav-index">{{section.number}}</span>
                    <span class="nav-label icon-right" style="white-space: normal;">
                      {{section.name}}
                      @if (section.completed) {
                        <span class="sidebar-icon icon-gecko-check"></span>
                      }
                    </span>
                  </a>
                }
                @if (isOffline && !section.availableOffline) {
                  <a class="btn" (click)="offlineModal()" aria-label="link button disabled"
                    >
                    @if (section.availableOffline) {
                      <span class="nav-index">{{section.number}}</span>
                    }
                    @if (!section.availableOffline) {
                      <span class="nav-index icon-gecko-unavailable" style="padding-right: 3px;padding-top: 4px;"></span>
                    }
                    <span class="nav-label icon-right" style="white-space: normal;">
                      {{section.name}}
                      @if (section.completed) {
                        <span class="sidebar-icon icon-gecko-check"></span>
                      }
                    </span>
                  </a>
                }
              </li>
            }
          </ul>
        </li>
      }
    </div>
  </ul>
}